import React from 'react';

export const Bold = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" {...props}>
      <path d="M5.333 7.333h3a1.667 1.667 0 0 0 0-3.333h-3v3.333Zm6.667 3a3 3 0 0 1-3 3H4V2.667h4.333a3 3 0 0 1 2.171 5.07A2.999 2.999 0 0 1 12 10.333ZM5.333 8.667V12H9a1.667 1.667 0 0 0 0-3.333H5.333Z" />
    </svg>
  );
};

export const Italic = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" {...props}>
      <path d="M10 13.333H4.667V12h1.95l1.411-8H6V2.667h5.333V4h-1.95l-1.411 8H10v1.333Z" />
    </svg>
  );
};

export const UnorderedList = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" {...props}>
      <path d="M5.333 2.667H14V4H5.333V2.667ZM3 4.333a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM3 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 4.6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.333-6.267H14v1.334H5.333V7.333Zm0 4.667H14v1.333H5.333V12Z" />
    </svg>
  );
};

export const OrderedList = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" {...props}>
      <path d="M3.833 2.333h-.688l-.978.262v1.036l.666-.18v2.216H2v1h2.667v-1h-.834V2.333Zm2.834.334H14V4H6.667V2.667Zm0 4.666H14v1.334H6.667V7.333Zm0 4.667H14v1.333H6.667V12Zm-4.75-1.583a1.417 1.417 0 1 1 2.541.86l-.003.005-.911 1.051h1.123v1H2v-.747l1.648-1.896a.417.417 0 1 0-.73-.31l-.008.203h-.993v-.166Z" />
    </svg>
  );
};

export const MediaEmbed = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" {...props}>
      <path d="M2.667 2A1.333 1.333 0 0 0 1.333 3.333v9.334A1.333 1.333 0 0 0 2.667 14h10.666a1.333 1.333 0 0 0 1.334-1.333V3.333A1.333 1.333 0 0 0 13.333 2H2.667Zm0 1.333h10.666v9.334H2.667V3.333Zm3.666 1.834a.5.5 0 0 0-.5.5v4.666a.5.5 0 0 0 .75.433l4-2.333a.5.5 0 0 0 0-.866l-4-2.333a.5.5 0 0 0-.25-.067Z" />
    </svg>
  );
};
